// extracted by mini-css-extract-plugin
export default {"billing_data":"jv","delivery_details":"kv","details_wrapper":"lv","title":"mv","detail_item":"nv"};
    if(module.hot) {
      // 1713996746550
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  